import cx from 'classnames'
import React, { useCallback } from 'react'
import ExpandableComponentIcon from './ExpandableComponentIcon'
import styles from './ExpandableSectionTitle.module.scss'

export interface Props
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  > {
  isExpanded: boolean
  setExpanded: (expanded: boolean) => void
}

const ExpandableSectionTitle = ({
  isExpanded,
  setExpanded,
  children,
  className,
  ...props
}: Props) => {
  const toggle = useCallback(() => {
    setExpanded(!isExpanded)
  }, [isExpanded, setExpanded])
  return (
    <h2 {...props} className={cx(styles.title, className)} onClick={toggle}>
      {children}
      <ExpandableComponentIcon isExpanded={isExpanded} />
    </h2>
  )
}

export default ExpandableSectionTitle
